import { render, staticRenderFns } from "./SiteItem.vue?vue&type=template&id=36b9731a&scoped=true&"
import script from "./SiteItem.vue?vue&type=script&lang=js&"
export * from "./SiteItem.vue?vue&type=script&lang=js&"
import style0 from "./SiteItem.vue?vue&type=style&index=0&id=36b9731a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9731a",
  null
  
)

export default component.exports